import refinementsFromUrl from './refinementsFromUrl';
import queryFromRefinements from './queryFromRefinements';

export default {
  getQueryFromUrl() {
    const pathName = window.location.pathname;
    const search = window.location.search;
    const refinements = refinementsFromUrl(pathName + search);
    return queryFromRefinements(refinements);
  },
};
